module.exports = __webpack_public_path__ + "img/6.791a59a5.webp";